import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  fonts: {
    heading: "'Tenor Sans', sans-serif",
    body: "'Tenor Sans', sans-serif",
  },
  colors: {
    pastelBlue: "#AFCBFF",
    pastelGreen: "#A2D2BF",
    pastelPink: "#FFCAD4",
    pastelYellow: "#FFE4B5",
    pastelWhite: "#FFFDFE",
    pastelGray: "#F7F8FA", // Soft gray for neutral areas
  },
  semanticTokens: {
    shadows: {
      softShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      mediumShadow: "0 8px 10px rgba(0, 0, 0, 0.15)",
      strongShadow: "0 12px 16px rgba(0, 0, 0, 0.2)",
      sectionShadow: "0px 6px 15px rgba(0, 0, 0, 0.1)", // For sections/cards
    },
  },
  textStyles: {
    h1: {
      fontSize: ["2.5rem", "3rem"], // Responsive heading
      fontWeight: "bold",
      lineHeight: "1.2",
    },
    h2: {
      fontSize: ["2rem", "2.5rem"],
      fontWeight: "semibold",
      lineHeight: "1.3",
    },
    h3: {
      fontSize: ["1.5rem", "2rem"],
      fontWeight: "medium",
      lineHeight: "1.4",
    },
    body: {
      fontSize: ["1rem", "1.125rem"],
      lineHeight: "1.6",
    },
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: "bold",
        borderRadius: "full",
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)", // Soft shadow for buttons
      },
      variants: {
        solid: {
          bg: "pastelPink",
          color: "white",
          _hover: { bg: "pastelBlue", boxShadow: "0px 6px 8px rgba(0, 0, 0, 0.15)" },
        },
        outline: {
          borderColor: "pastelPink",
          color: "pastelPink",
          _hover: { bg: "pastelBlue", color: "white" },
        },
        ghost: {
          color: "pastelBlue",
          _hover: { bg: "pastelGray", color: "pastelPink" },
        },
      },
      sizes: {
        lg: { fontSize: "1.25rem", px: 6, py: 4 },
        md: { fontSize: "1rem", px: 4, py: 3 },
        sm: { fontSize: "0.875rem", px: 3, py: 2 },
      },
    },
    Box: {
      baseStyle: {
        borderRadius: "md",
        boxShadow: "softShadow",
      },
    },
  },
  shadows: {
    card: "0 8px 20px rgba(0, 0, 0, 0.12)", // For cards
    modal: "0 10px 40px rgba(0, 0, 0, 0.25)", // For modal dialogs
    buttonHover: "0 6px 10px rgba(0, 0, 0, 0.1)", // For button hover
  },
  styles: {
    global: {
      body: {
        fontFamily: "'Tenor Sans', sans-serif",
        bg: "pastelWhite",
        color: "gray.800",
        lineHeight: "base",
        fontSize: ["16px", "18px"], // Responsive font size
        margin: 0,
      },
      a: {
        color: "pastelBlue",
        fontWeight: "medium",
        _hover: {
          textDecoration: "underline",
          color: "pastelPink",
        },
      },
      h1: {
        color: "pastelBlue",
      },
      h2: {
        color: "pastelGreen",
      },
      button: {
        _focus: {
          boxShadow: "none",
        },
      },
    },
  },
});

export default theme;
